import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import {
  fontSize,
  sectionMargins,
  minBreakpointQuery,
  fontWeights,
} from '../styles';
import { Container, SectionHeader, SectionFooter } from './ui';

const StyledInstagramFeed = styled.section`
  ${sectionMargins()};
`;

const StyledItems = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 1fr);

  ${minBreakpointQuery.tsmall`
    grid-template-columns: repeat(2, 1fr);
  `}

  ${minBreakpointQuery.large`
    grid-template-columns: repeat(4, 1fr);
  `}
`;

const StyledItem = styled.article``;

const StyledImage = styled(GatsbyImage)`
  width: 100%;
`;

const StyledText = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 8;
  overflow: hidden;
  margin-top: 20px;

  ${minBreakpointQuery.small`
    ${fontSize(17)};
  `}

  ${minBreakpointQuery.small`
    ${fontSize(18)};
  `}

  span {
    font-weight: ${fontWeights.bold};
  }
`;

const InstagramFeed = ({ heading, text }) => {
  const {
    contentfulSitewide: { instagramLink },
    allInstagramPost: { nodes: items },
  } = useStaticQuery(graphql`
    query InstagramFeedQuery {
      contentfulSitewide {
        instagramLink {
          ...LinkFragment
        }
      }
      allInstagramPost(limit: 4) {
        nodes {
          id
          image {
            childImageSharp {
              gatsbyImageData(width: 360, height: 360)
            }
          }
          caption
          permalink
        }
      }
    }
  `);

  return (
    items &&
    items.length > 0 && (
      <StyledInstagramFeed>
        <Container>
          <SectionHeader heading={heading} text={text} />
          <StyledItems>
            {items.map(({ image, caption }, id) => {
              const gatsbyImage = getImage(image);

              return (
                <StyledItem key={id}>
                  <StyledImage
                    image={gatsbyImage}
                    alt="Instagram Placeholder Image"
                    loading="lazy"
                  />
                  <StyledText>
                    <span>MyEcotalk</span> {caption}
                  </StyledText>
                </StyledItem>
              );
            })}
          </StyledItems>
          <SectionFooter
            link={{
              text: 'Follow us',
              pageUrl: instagramLink,
            }}
          />
        </Container>
      </StyledInstagramFeed>
    )
  );
};
export default InstagramFeed;
